/**
 * Error error models
 */

/**
 * FantazUIError is the base error class for all FantazUI errors.
 */
export class FantazUIError extends Error {
  // A unique string that identifies a resource.
  key: string;

  /**
   * Constructs a new FantazUIError object.
   * @param message string - A human-readable description of the error.
   * @param key  string - A unique string that identifies a resource.
   */
  constructor(message: string, key?: string) {
    super(message);
    this.key = key || 'UNKNOWN_ERROR';
  }

  override toString(): string {
    return this.message || this.key;
  }
}

export class OldPasswordInvalid extends Error {
  constructor() {
    super('Invalid old password');
  }
}
export class ChangePasswordLimitExceededException extends Error {
  constructor() {
    super(
      'Change password attempt limit exceeded, please try after some time.',
    );
  }
}

export class NotEnoughBalanceException extends Error {
  constructor() {
    super('Not enough balance');
  }
}

export class EscalateException extends Error {
  constructor() {
    super('ESCALATE');
  }
}

export class UnknownErrorException extends Error {
  constructor() {
    super('UNKNOWN_ERROR');
  }
}

export class TsevoErrorException extends Error {
  constructor() {
    super('TSEVO_ERROR');
  }
}

export class SessionInProgressException extends Error {
  constructor() {
    super('SESSION_IN_PROGRESS');
  }
}

export class SessionTimeoutException extends Error {
  constructor() {
    super('SESSION_TIMEOUT');
  }
}

export class SessionIneligibleException extends Error {
  constructor() {
    super('SESSION_INELIGIBLE');
  }
}

export class SessionIncompleteException extends Error {
  constructor() {
    super('SESSION_INCOMPLETE');
  }
}

export class AvsUnavailableException extends Error {
  constructor() {
    super('AVS_UNAVAILABLE');
  }
}

export class AvsPartialMatchException extends Error {
  constructor() {
    super('AVS_PARTIAL_MATCH');
  }
}

export class AvsNoMatchException extends Error {
  constructor() {
    super('AVS_NO_MATCH');
  }
}

export class CcvUnavailableException extends Error {
  constructor() {
    super('CCV_UNAVAILABLE');
  }
}

export class CcvNoMatchException extends Error {
  constructor() {
    super('CCV_NO_MATCH');
  }
}
